import { useDistributorsApi } from "../../../common/api/catalogue-api/distributors/useDistributorsApi";

export const useAdminDistributorsApi = () => {
    const { createDistributor, getDistributorsList } = useDistributorsApi();

    return {
        createDistributor,
        getDistributorsList
    };
};
